// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__BE2UA","head":"Modal_head__eMzgs","paragraph":"Modal_paragraph__WZ6ed","button":"Modal_button__FFRRp"};